import axios from 'axios';
import { FETCH_CACHED_CMS_DATA_URL, APP_DOMAIN } from 'appenv';

const fetchCachedCMSData = async (fileName) => {
  const eventDomain = APP_DOMAIN;
  const cmsCachedDataFileName = fileName || `event_${eventDomain}_data`;
  const response = await axios.get(
    `${FETCH_CACHED_CMS_DATA_URL}/${cmsCachedDataFileName}`,
  );
  try {
    return typeof response.data === 'string'
      ? JSON.parse(
        response.data
          .split('=>').join(':')
          .split('nil').join('null'),
      )
      : response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export default fetchCachedCMSData;
